import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';
import { STORAGE_NAMES } from '@root/app.config';
import * as _ from 'lodash';
import { Retailer } from '@root/app.interfaces';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { ModalService } from '@core/services/modal/modal.service';
import { GtmService } from '@core/services/gtm/gtm.service';

@Component({
	selector: 'app-retailer-success-modal',
	templateUrl: './retailer-success-modal.component.html',
	styleUrls: ['./retailer-success-modal.component.scss', 'retailer-success-modal.responsive.scss'],
})
export class RetailerSuccessModalComponent implements OnInit, OnDestroy {
	checkedRetailers = [];
	embeddedRetailer: Retailer = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_embedded_retailer);

	constructor(
		public dialogRef: MatDialogRef<RetailerSuccessModalComponent>,
		private countryCodeService: SetupPageService,
		private sessionStorageService: SessionStorageService,
		private modalService: ModalService,
		private gtmService: GtmService,

		@Inject(MAT_DIALOG_DATA) public data: any,
	) {}

	getDialogClosed: Subscription;

	ngOnInit(): void {
		this.modalService.liftUpModal(this.dialogRef);
		this.getCheckedRetailers();

		this.gtmService.pushEvent({
			event: 'primary_conversion',
			conversion_type: 'onsite_consultation_requested',
			retailer: this.checkedRetailers[0]?.name,
		});

		this.getDialogClosed = this.dialogRef.beforeClosed().subscribe(() => {
			this.countryCodeService.resetOnBeforeUnloadHandler();
			window.location.href = '/home';
		});
	}

	ngOnDestroy(): void {
		this.getDialogClosed.unsubscribe();
	}

	close(): void {
		this.countryCodeService.parseLocalLinkHandler();
	}

	getCheckedRetailers(): void {
		if (!_.isEmpty(this.data)) {
			this.checkedRetailers = [
				...new Set(
					[...this.data.nonPremiumMarkers, ...this.data.premiumMarkers].filter((marker) =>
						this.data.checkedRetailersID.includes(marker.id),
					),
				),
			].map((retailer) => ({ name: retailer.name, website: retailer.website }));
		}
	}
}
